import { CommonError } from '../../../../stores/app-state-errors';
import {
  ERR_PARAM_AUTHORIZATION_CODE_INVALID,
  ERR_PARAM_CONSENT_ID_INVALID,
} from '../../../../utilities/error';
import { ValidateProductParams } from '../../../../utilities/urlParameters';

export const validateParams: ValidateProductParams = (commonParameters) => {
  const errors: CommonError[] = [];

  const { consentId, authorizationCode, authorizationToken } = commonParameters;

  if (!consentId) {
    errors.push(ERR_PARAM_CONSENT_ID_INVALID);
  }

  if (!authorizationCode && !authorizationToken) {
    errors.push(ERR_PARAM_AUTHORIZATION_CODE_INVALID);
  }

  return {
    parameters: { refreshableItems: [] },
    errors,
  };
};
